// src/utils/ndviColors.js

// Professional NDVI Color Scale (23 steps)
// Labels are now translation keys
export const ndviColorScale = [
  { min: -1.00, max: -0.05, color: '#8B0000', labelKey: 'bare_soil' },
  { min: -0.05, max: 0.00, color: '#A52A2A', labelKey: 'bare_soil' },
  { min: 0.00, max: 0.05, color: '#DC143C', labelKey: 'bare_soil' },
  { min: 0.05, max: 0.10, color: '#FF0000', labelKey: 'bare_soil' },
  { min: 0.10, max: 0.15, color: '#FF4500', labelKey: 'bare_soil' },
  { min: 0.15, max: 0.20, color: '#FF6347', labelKey: 'bare_soil' },
  { min: 0.20, max: 0.25, color: '#FF8C00', labelKey: 'sparse_vegetation' },
  { min: 0.25, max: 0.30, color: '#FFA500', labelKey: 'sparse_vegetation' },
  { min: 0.30, max: 0.35, color: '#FFD700', labelKey: 'sparse_vegetation' },
  { min: 0.35, max: 0.40, color: '#FFFF00', labelKey: 'sparse_vegetation' },
  { min: 0.40, max: 0.45, color: '#ADFF2F', labelKey: 'medium_density' },
  { min: 0.45, max: 0.50, color: '#9ACD32', labelKey: 'medium_density' },
  { min: 0.50, max: 0.55, color: '#7FFF00', labelKey: 'medium_density' },
  { min: 0.55, max: 0.60, color: '#00FF00', labelKey: 'medium_density' },
  { min: 0.60, max: 0.65, color: '#32CD32', labelKey: 'dense_vegetation' },
  { min: 0.65, max: 0.70, color: '#228B22', labelKey: 'dense_vegetation' },
  { min: 0.70, max: 0.75, color: '#008000', labelKey: 'dense_vegetation' },
  { min: 0.75, max: 0.80, color: '#006400', labelKey: 'dense_vegetation' },
  { min: 0.80, max: 0.85, color: '#004d00', labelKey: 'dense_vegetation' },
  { min: 0.85, max: 0.90, color: '#003d00', labelKey: 'dense_vegetation' },
  { min: 0.90, max: 0.95, color: '#003200', labelKey: 'dense_vegetation' },
  { min: 0.95, max: 1.00, color: '#002800', labelKey: 'dense_vegetation' },
  { min: 1.00, max: 1.10, color: '#001e00', labelKey: 'use_ndre' }
];

/**
 * Granular Color Ramp for RGB-to-Value interpolation
 */
export const ndviColorRamp = [
  { ndvi: -1.00, color: '#8B0000' },
  { ndvi: -0.05, color: '#A52A2A' },
  { ndvi: 0.00, color: '#DC143C' },
  { ndvi: 0.05, color: '#FF0000' },
  { ndvi: 0.10, color: '#FF4500' },
  { ndvi: 0.15, color: '#FF6347' },
  { ndvi: 0.20, color: '#FF8C00' },
  { ndvi: 0.25, color: '#FFA500' },
  { ndvi: 0.30, color: '#FFD700' },
  { ndvi: 0.35, color: '#FFFF00' },
  { ndvi: 0.40, color: '#ADFF2F' },
  { ndvi: 0.45, color: '#9ACD32' },
  { ndvi: 0.50, color: '#7FFF00' },
  { ndvi: 0.55, color: '#00FF00' },
  { ndvi: 0.60, color: '#32CD32' },
  { ndvi: 0.65, color: '#228B22' },
  { ndvi: 0.70, color: '#008000' },
  { ndvi: 0.75, color: '#006400' },
  { ndvi: 0.80, color: '#004d00' },
  { ndvi: 0.85, color: '#003d00' },
  { ndvi: 0.90, color: '#003200' },
  { ndvi: 0.95, color: '#002800' },
  { ndvi: 1.00, color: '#001e00' }
];

export const getNdviColor = (ndvi) => {
  if (ndvi === null || ndvi === undefined) return '#cccccc';

  // Find the matching range
  const range = ndviColorScale.find(r => ndvi >= r.min && ndvi < r.max);
  if (range) return range.color;

  // Edge cases
  if (ndvi >= 1.0) return '#001e00';
  if (ndvi < -1.0) return '#8B0000';

  return '#cccccc';
};

/**
 * Get NDVI description with translation support
 * @param {number} ndvi - NDVI value
 * @param {function} t - Translation function from useTranslation (optional)
 * @returns {string} Translated description
 */
export const getNdviDescription = (ndvi, t = null) => {
  if (ndvi === null || ndvi === undefined) {
    return t ? t('ndvi.no_data') : 'Veri Yok';
  }
  const range = ndviColorScale.find(r => ndvi >= r.min && ndvi < r.max);
  if (range) {
    return t ? t(`ndvi.${range.labelKey}`) : range.labelKey;
  }
  return t ? t('ndvi.unknown') : 'Bilinmiyor';
};
